export default __webpack_public_path__ + "static/media/infinity.46363660.gif";